export const environment = {
	production: false,
	enableCache: true,
	demoApi: 'https://api-services.uat.1placedessaisons.com/uatr/eakteplus-document-metadata-api/v1',
	idp: {
		issuer: 'https://api-services.uat.1placedessaisons.com/uatr/v1/oidc',
		issuerV2: 'https://api-services.uat.1placedessaisons.com/uatr/auth/v2/oidc',
		useV2Oidc: false,
		clientId: '6zONy6HaawMoF3FGJVIAJq4xwfoa',
	},

	firebase: {
		apiKey: "__FIREBASE_API_KEY__",
		authDomain: "eakteplusui-e99c3.firebaseapp.com",
		projectId: "eakteplusui-e99c3",
		storageBucket: "eakteplusui-e99c3.firebasestorage.app",
		messagingSenderId: "465908741861",
		appId: "1:465908741861:web:00324faf1cd3b4a185860c",
		measurementId: "G-KM2C24V7FT"

	},
};
